import ArrowBackRounded from "@mui/icons-material/ArrowBackRounded";
import IconButton from "@mui/material/IconButton";
import StoreTidMaster from "./StoreTidMaster/StoreTidMaster";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { useNavigate, useOutletContext } from "react-router-dom";
import { posDashboardSideNavList } from "./data";
import { CustomLinearProgress } from "components/ReusableComponents/CustomLinearProgress/CustomLinearProgress";
import RareBoxLogo from "Logos/RareBoxLogo";
import { useEffect, useState } from "react";
import { services, rootProtectedPath } from "data/authData";
import { Breadcrumbs } from "@mui/material";
import { grey } from "@mui/material/colors";
import { PosRecoState } from "context/PosRecoContext";
import FileUpload from "./FileUpload/FileUpload.js";
import Summary from "./Summary/Summary.js";
import Jobs from "./Jobs/Jobs";
import Report from "./Reports/Reports";

const APP_NAV_HEIGHT = 64;
const DASHBOARD_HEADING_HEIGHT = 16;

const PosReco = () => {
	const [currentPath, service] = useOutletContext();
	const [serviceDisplayname, setServiceDisplayName] = useState();
	const { reportLoading, socket, sessionData, setService, setSessionData } = PosRecoState();

	useEffect(() => {
		setService(service);
		const url = window.location.pathname;
		setServiceDisplayName(url?.split(`/${rootProtectedPath}/${services.pos_reco.path.split("/")[0]}/`)?.[1] ?? service.name);
	}, [service]);
	const navigate = useNavigate();

	const tabComponents = {
		[posDashboardSideNavList.HOME.key]: {
			...posDashboardSideNavList.HOME,
			component: <Summary />,
		},
		[posDashboardSideNavList.FILE_UPLOAD.key]: {
			...posDashboardSideNavList.FILE_UPLOAD,
			component: <FileUpload />,
		},

		// [posDashboardSideNavList.FILE_UPLOAD.key]: {
		// 	...posDashboardSideNavList.FILE_UPLOAD,
		// 	component: <FileUpload />,
		// },

		[posDashboardSideNavList.STORE_MASTER.key]: {
			...posDashboardSideNavList.STORE_MASTER,
			component: <StoreTidMaster />,
		},
		[posDashboardSideNavList.JOBS.key]: {
			...posDashboardSideNavList.JOBS,
			component: <Jobs />,
		},
		[posDashboardSideNavList.REPORT.key]: {
			...posDashboardSideNavList.REPORT,
			component: <Report />,
		},
	};

	return (
		<Box
			sx={{
				width: "100%",
				height: `calc(100vh - ${APP_NAV_HEIGHT}px - ${DASHBOARD_HEADING_HEIGHT}px)`,
				minHeight: 0,
				p: 1,
				pt: 0,
				boxSizing: "border-box",
				display: "flex",
				flexDirection: "column",
			}}>
			<Box display="flex" alignItems="center" columnGap={1}>
				<IconButton onClick={() => navigate(-1)}>
					<ArrowBackRounded />
				</IconButton>
				<Breadcrumbs>
					{serviceDisplayname
						?.split("/")
						.reduce((acc, row, i, arr) => {
							if (i !== arr.length - 1)
								acc.push(
									<Typography sx={{ color: grey[600] }} variant="h6" fontSize={18} textTransform="capitalize">
										{row.toLowerCase().split("_")?.join(" ")}
									</Typography>,
								);
							return acc;
						}, [])
						.map((row) => row)}
					<Typography sx={{ color: "text.primary" }} variant="h6" fontSize={18} textTransform="capitalize">
						{service.name}
					</Typography>
				</Breadcrumbs>
				{/* <Typography variant="h5">{service?.name}</Typography> */}
			</Box>

			<Box
				width="100%"
				height="100%"
				display="flex"
				alignItems="center"
				justifyContent="center"
				sx={{ display: reportLoading ? "block" : "none" }}>
				<div
					style={{
						width: "200px",
						position: "absolute",
						left: "50%",
						top: "50%",
						transform: "translate(-50%,-50%)",
					}}>
					<RareBoxLogo />
					<CustomLinearProgress />
				</div>
			</Box>
			<Box
				width="100%"
				flex={1}
				minHeight={0}
				display="flex"
				alignItems="stretch"
				sx={{ display: reportLoading ? "none" : "flex" }}>
				{tabComponents?.[currentPath]?.component}
			</Box>
		</Box>
	);
};

export default PosReco;
